'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabContainer = function (_React$Component) {
    _inherits(TabContainer, _React$Component);

    function TabContainer(props) {
        _classCallCheck(this, TabContainer);

        var _this = _possibleConstructorReturn(this, (TabContainer.__proto__ || Object.getPrototypeOf(TabContainer)).call(this, props));

        _this.state = {
            selected: props.selected
        };

        _this.generateTabLinks = _this.generateTabLinks.bind(_this);
        _this.renderTabContent = _this.renderTabContent.bind(_this);
        _this.renderTabTitle = _this.renderTabTitle.bind(_this);
        _this.handleTabClick = _this.handleTabClick.bind(_this);
        return _this;
    }

    _createClass(TabContainer, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(props) {

            if (props.activePropsState) {
                this.setState({ selected: props.selected });
            }
        }
    }, {
        key: 'renderTabContent',
        value: function renderTabContent() {
            return _react2.default.createElement(
                'div',
                { className: 'tab-content' },
                _react2.default.cloneElement(this.props.children[this.state.selected], { 'isActive': true })
            );
        }
    }, {
        key: 'handleTabClick',
        value: function handleTabClick(index, onTabClick, event) {
            event.preventDefault();
            this.setState({
                selected: index
            }, onTabClick);
        }
    }, {
        key: 'generateTabLinks',
        value: function generateTabLinks(child, index) {

            /* check the pickkup ordering is disabled or not
            *  check the order type is Pickup
            * */
            // let isPickupDisable = MainStore.isPickUpOrderDisabled();
            var activeClass = '';
            // if (isPickupDisable && child.props.label == "PICK UP") {
            //     // do not show the accent color in background
            //     // if pickup ordering is disabled
            // }
            // else {
            activeClass = this.state.selected === index ? 'active-styl' : '';
            // }

            var comp = "";

            // hide the tab container
            if (Utils.isEmpty(child.props.isHiddenDiv) && child.props.isHiddenDiv == false) {
                comp = _react2.default.createElement(
                    'button',
                    {
                        key: index,
                        type: 'button',
                        className: this.props.tabLinksClassNames + ' ' + activeClass,
                        onClick: this.handleTabClick.bind(this, index, child.props.onTabClick)
                    },
                    child.props.label
                );
            }

            return comp;
        }
    }, {
        key: 'renderTabTitle',
        value: function renderTabTitle() {
            return (
                // <div className="btn-group btn-group-justified">
                _react2.default.createElement(
                    'div',
                    { className: 'btn-group btn-group-toggle w-100 ' },
                    this.props.children.map(this.generateTabLinks)
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: this.props.classNames },
                this.renderTabTitle(),
                this.renderTabContent()
            );
        }
    }]);

    return TabContainer;
}(_react2.default.Component);

exports.default = TabContainer;


TabContainer.propTypes = {
    selected: _propTypes2.default.number
};

TabContainer.defaultProps = {
    selected: 0,
    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]).isRequired
};


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/TabContainer.js
// module id = 489
// module chunks = 0